interface FeatureCardProps {
  title: string;
  description: string;
}

export function FeatureCard({ title, description }: FeatureCardProps) {
  return (
    <div className="rounded-lg bg-gray-50 p-4">
      <h3 className="mb-2 font-medium">{title}</h3>

      <p className="text-sm text-gray-600">{description}</p>
    </div>
  );
}
